import { Injectable } from '@angular/core';
import { DcLocalStorage } from '@datachain/ui-sdk/common';

import { UserPreference, ViewMode } from '../domain/user-preference';

@Injectable({
	providedIn: 'root',
})
export class PreferenceStorage extends DcLocalStorage<UserPreference> {
	protected key = 'user-preference';
	private preference;

	public constructor() {
		super();
		this.preference = new UserPreference();
		this.synchronize();
	}

	public getValue(): UserPreference {
		return this.preference;
	}

	public getSharedElemsViewMode(): ViewMode {
		return this.preference.sharedElemsViewMode;
	}

	public setViewMode(val: UserPreference): void {
		this.setStorage(val);
	}

	private synchronize(): void {
		const stored = this.getStorage();
		if (stored) {
			this.preference = UserPreference.build(stored);
		} else {
			this.setStorage(this.preference);
		}
	}
}
